import { render, staticRenderFns } from "./audioPlayer.vue?vue&type=template&id=add675be&"
import script from "./audioPlayer.vue?vue&type=script&lang=js&"
export * from "./audioPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports